<div class="cf-dlg bti">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>receipt_long</mat-icon></div>
    <div class="bti-header-text">
      <h2 class="cf-dlg-title">Importar extracto bancario</h2>
      <p class="cf-dlg-subtitle">{{ subtitle }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="closeDialog()" [disabled]="loading" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="loading" [message]="'Importando ' + (fileName || 'extracto') + '…'"></app-loading-state>

  <ng-container *ngIf="!loading && !imported">
    <div class="cf-dlg-body">
      <span class="cf-dlg-section__label">1. Descarga la plantilla</span>
      <p class="bti-hint">Rellena una fila por movimiento con la fecha, el concepto y el importe tal y como aparecen en tu banco.</p>
      <button type="button" class="cf-dlg-upload-btn bti-tile" (click)="downloadTemplate()">
        <mat-icon>description</mat-icon>
        Descargar plantilla Excel
      </button>

      <span class="cf-dlg-section__label bti-section">2. Sube el extracto completado</span>
      <label class="cf-dlg-upload-btn bti-drop" for="bank-transaction-import-file"
        [class.bti-drop--over]="dragOver"
        (dragover)="onDragOver($event)" (dragleave)="dragOver = false" (drop)="onDrop($event)">
        <mat-icon>cloud_upload</mat-icon>
        <span class="bti-drop__title">Arrastra aquí el archivo o haz clic para seleccionarlo</span>
        <span class="bti-drop__hint">Excel (.xlsx) con el formato de la plantilla</span>
      </label>
      <input id="bank-transaction-import-file" type="file" accept=".xlsx" (change)="fileChange($event)" hidden />

      <div class="bti-alert" *ngIf="errorMessage">
        <mat-icon>error</mat-icon>
        <span>{{ errorMessage }}</span>
      </div>

      <p class="bti-note">
        <mat-icon>info</mat-icon>
        Los movimientos que ya existan en Handly no se duplican. Después podrás conciliarlos desde Conciliación bancaria.
      </p>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cerrar</button>
    </div>
  </ng-container>

  <ng-container *ngIf="!loading && imported">
    <div class="cf-dlg-body">
      <div class="bti-done">
        <div class="bti-done__icon"><mat-icon>check</mat-icon></div>
        <span class="bti-done__title">Extracto importado</span>
        <span class="bti-done__file">{{ fileName }}</span>
        <span class="bti-done__hint">Los movimientos ya están disponibles para conciliar.</span>
      </div>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="reset()">
        <mat-icon>upload_file</mat-icon> Importar otro
      </button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="closeDialog()">Hecho</button>
    </div>
  </ng-container>
</div>
